import { Component, DOCUMENT, HostListener, inject, OnInit } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import * as WebshopActions from './store/webshop/webshop.actions';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [AvatarModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Het Raaymakers Antiek & Interieur - Gespecialiseerd in 17e 18e en 19 eeuwse antiquiteiten';

  private document = inject(DOCUMENT);
  private store = inject(Store);

  ngOnInit() {
    this.store.dispatch(WebshopActions.loadWebshopData());
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.document.body.scrollTop <= 0 || this.document.documentElement.scrollTop <= 0) {
      document.getElementById('header')?.classList.remove('sticky');
    }
    if (this.document.body.scrollTop > 20 || this.document.documentElement.scrollTop > 20) {
      document.getElementById('header')?.classList.add('sticky');
    }
  }
}
